/* eslint-disable graphql/template-strings */
import gql from 'graphql-tag';

export const SubscriptionCheckoutPage = gql`
  fragment subscriptionCheckoutQuery on LayoutContent {
    subscriptionCheckoutAsset: vcmsAsset(
      structure: "GenericSubscriptionCheckoutPage"
      properties: { cmsidentifier: $subscriptionCheckoutCmsIdentifier }
    )
  }
`;
